<div class="modals info-message-modal" [class.modals-show]="isModalHistoryShow"
     [class.modals-hide]="!isModalHistoryShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h2 class="text-center">Повідомлення</h2>

  <div class="google-review-block">
    <p class="google-review-text">Залиште нам відгук у Google. Для нас це важливо.</p>
    <a
      class="google-review-link"
      href="https://g.page/r/CX-p9s9FOf0nEBM/review"
      target="_blank"
      rel="noopener noreferrer">
      Залишити відгук
    </a>
  </div>

  <hr>
  <h3 class="text-center-msg" *ngIf="!(infoMessageList.length > 0)">Повідомлення відсутні.</h3>
  <br>
  <ul *ngIf="infoMessageList.length > 0">
    <li *ngFor="let message of infoMessageList; let i = index">
      <small>{{message.created}} &nbsp; &nbsp; &nbsp; активно до: {{message.til}}</small>
      <span [innerHTML]="message.text"></span>
      <hr>
      <a class="delete-user-notify" (click)="deleteUserNotifyMess(message.id, i)">
        <i class="fa fa-times" aria-hidden="true"></i>
      </a>
    </li>
  </ul>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
